var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_90_11602",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 19
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 19.3047,
    height: 19,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_90_11602)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.4349 13.4583C6.6628 13.4583 6.85397 13.3823 7.00841 13.2303C7.16231 13.0789 7.23926 12.891 7.23926 12.6667C7.23926 12.4424 7.16231 12.2542 7.00841 12.1022C6.85397 11.9507 6.6628 11.875 6.4349 11.875C6.207 11.875 6.01583 11.9507 5.86139 12.1022C5.70749 12.2542 5.63054 12.4424 5.63054 12.6667C5.63054 12.891 5.70749 13.0789 5.86139 13.2303C6.01583 13.3823 6.207 13.4583 6.4349 13.4583ZM6.4349 10.2917C6.6628 10.2917 6.85397 10.2157 7.00841 10.0637C7.16231 9.91219 7.23926 9.72431 7.23926 9.5C7.23926 9.27569 7.16231 9.08754 7.00841 8.93554C6.85397 8.78407 6.6628 8.70833 6.4349 8.70833C6.207 8.70833 6.01583 8.78407 5.86139 8.93554C5.70749 9.08754 5.63054 9.27569 5.63054 9.5C5.63054 9.72431 5.70749 9.91219 5.86139 10.0637C6.01583 10.2157 6.207 10.2917 6.4349 10.2917ZM6.4349 7.125C6.6628 7.125 6.85397 7.049 7.00841 6.897C7.16231 6.74553 7.23926 6.55764 7.23926 6.33333C7.23926 6.10903 7.16231 5.92088 7.00841 5.76888C6.85397 5.6174 6.6628 5.54167 6.4349 5.54167C6.207 5.54167 6.01583 5.6174 5.86139 5.76888C5.70749 5.92088 5.63054 6.10903 5.63054 6.33333C5.63054 6.55764 5.70749 6.74553 5.86139 6.897C6.01583 7.049 6.207 7.125 6.4349 7.125ZM8.84799 13.4583H13.6742V11.875H8.84799V13.4583ZM8.84799 10.2917H13.6742V8.70833H8.84799V10.2917ZM8.84799 7.125H13.6742V5.54167H8.84799V7.125ZM4.02181 16.625C3.57941 16.625 3.20056 16.4701 2.88525 16.1603C2.57047 15.85 2.41309 15.4771 2.41309 15.0417V3.95833C2.41309 3.52292 2.57047 3.15004 2.88525 2.83971C3.20056 2.5299 3.57941 2.375 4.02181 2.375H15.2829C15.7253 2.375 16.1041 2.5299 16.4195 2.83971C16.7342 3.15004 16.8916 3.52292 16.8916 3.95833V15.0417C16.8916 15.4771 16.7342 15.85 16.4195 16.1603C16.1041 16.4701 15.7253 16.625 15.2829 16.625H4.02181ZM4.02181 15.0417H15.2829V3.95833H4.02181V15.0417Z",
    fill: "#004368"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.1cbcd3fec15b94339a10dfdc6286f89c.svg";
export { ForwardRef as ReactComponent };